import React, { useState, useEffect } from "react";

export default function QuoteSlider() {
  const quotes = [
    "मन को स्थिर करो — क्योंकि वही मंदिर है जहाँ ईश्वर निवास करता है।",
    "साधना का अर्थ भागना नहीं, भीतर लौटना है।",
    "ध्यान वह दीपक है जो अंधकार नहीं मिटाता, बल्कि तुम्हें दिखाता है कि तुम कौन हो।",
    "जो अपने भीतर ईश्वर को देख लेता है, उसे संसार में कुछ भी अधूरा नहीं लगता।",
    "दूसरों की सेवा ईश्वर की सबसे सुंदर पूजा है।",
    "जिसने करुणा को जीवन का आधार बना लिया, वह हर जीव में परमात्मा को देखता है।",
    "सेवा वह शक्ति है जो साधक को साधु बनाती है।",
    "अपने सुख के लिए नहीं, दूसरों के कल्याण के लिए जियो — यही सच्चा धर्म है।",
    "धर्म कोई परंपरा नहीं, जीवन का संतुलन है।",
    "सत्य को खोजने के लिए पहले स्वयं से सच्चे बनो।",
    "जिस हृदय में सत्य का दीपक जलता है, वहाँ अंधकार टिक नहीं सकता।",
    "धर्म वही है जो मनुष्य को मनुष्यता की ओर ले जाए।",
    "शांति पाने के लिए संसार को नहीं, अपने मन को बदलो।",
    "आत्मा जब ईश्वर में स्थिर हो जाती है, तब ही परम शांति प्राप्त होती है।",
    "विचारों का अंत ही ध्यान की शुरुआत है।",
    "जब तुम्हारा मन मौन हो जाए, तभी तुम ईश्वर की वाणी सुन पाते हो।",
    "समय को साधना है तो अहंकार को त्यागना होगा।",
    "ईश्वर ने जो दिया है, उसके लिए कृतज्ञ रहो — यही समृद्धि का रहस्य है।",
    "जो हुआ, वह भी ईश्वर की कृपा है; जो होगा, वह भी कृपा ही होगी।",
    "जीवन एक अवसर है — आत्मा को पहचानने का, न कि केवल भोगने का।"
  ];

  const [index, setIndex] = useState(0);

  // Auto change every 6.5s
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % quotes.length);
    }, 6500);

    return () => clearInterval(interval);
  }, [quotes.length]);

  const next = () => setIndex((i) => (i + 1) % quotes.length);
  const prev = () => setIndex((i) => (i - 1 + quotes.length) % quotes.length);

  return (
    <section id="teachings" style={{ padding: "28px 0" }}>
      <div className="container">
        <div className="card carousel" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <h3 title="Swami Brahmanand Saraswati" style={{ margin: "0", color: "var(--accent)" }}>स्वामी ब्रह्मानंद सरस्वती जी महाराज — प्रेरणादायक उद्धरण</h3>

          <div id="carousel" style={{ overflow: "hidden", position: "relative" }}>
            <div className="item" style={{padding: "14px",fontSize: "18px",textAlign: "center",minHeight: "120px",color: "#fff",transition: "opacity 0.4s ease",}}>
              “{quotes[index]}” — स्वामी ब्रह्मानंद सरस्वती जी महाराज
            </div>
          </div>

          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button className="btn" onClick={prev} style={{background: "transparent", border: "1px solid rgba(255,255,255,0.04)", color: "var(--muted)"}}>Prev</button>
            <button className="btn" onClick={next} style={{background: "transparent", border: "1px solid rgba(255,255,255,0.04)", color: "var(--muted)"}}>Next</button>
          </div>
        </div>
      </div>
    </section>
  );
}
